import {
  useEffect, useRef, useState,
} from 'react';
import { TooltipContainer, TooltipTip } from './tooltip.styled';

type TooltipProps = {
  delay?: number,
  content: string | JSX.Element,
  children: JSX.Element,
  disabled?: boolean,
}

const Tooltip = ({
  content,
  children,
  delay,
  disabled,
}: TooltipProps): JSX.Element => {
  let timeout: NodeJS.Timeout;
  const [active, setActive] = useState(false);
  const [elementHeight, setElementHeight] = useState<number>(0);
  const tooltipEl = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setElementHeight(tooltipEl?.current?.offsetHeight || 0);
  }, []);

  const showTip = () => {
    timeout = setTimeout(() => {
      setActive(true);
    }, delay || 400);
  };

  const hideTip = () => {
    clearInterval(timeout);
    setActive(false);
  };

  if (disabled) {
    return (
      <>
        { children }
      </>
    );
  }

  return (
    <>
      <TooltipContainer
        onMouseEnter={ showTip }
        onMouseLeave={ hideTip }
        ref={ tooltipEl }
      >
        { active && (
          <TooltipTip height={ elementHeight } className="top">
            { content }
          </TooltipTip>
        ) }
        { children }
      </TooltipContainer>
    </>
  );
};

Tooltip.defaultProps = {
  delay: undefined,
  disabled: false,
};

export default Tooltip;
